/* Manarola 2026 · collection.js — filtros sin recargar (Section Rendering API) con respaldo sin JS */
(() => {
  const { debounce, announce } = window.Manarola || {};
  const root = document.querySelector('[data-collection]');
  if (!root) return;
  const sectionId = root.dataset.sectionId;
  const results = () => root.querySelector('[data-collection-results]');
  let lastTrigger = null;

  const panel = () => root.querySelector('[data-facets]');
  const isMobile = () => window.matchMedia('(max-width: 989px)').matches;

  const openPanel = (trigger) => {
    const p = panel(); if (!p) return;
    lastTrigger = trigger;
    p.classList.add('is-open');
    p.setAttribute('role', 'dialog'); p.setAttribute('aria-modal', 'true');
    document.body.classList.add('facets-open');
    trigger && trigger.setAttribute('aria-expanded', 'true');
    p.querySelector('[data-facets-close]')?.focus();
  };
  const closePanel = () => {
    const p = panel(); if (!p || !p.classList.contains('is-open')) return;
    p.classList.remove('is-open');
    p.setAttribute('role', 'region'); p.removeAttribute('aria-modal');
    document.body.classList.remove('facets-open');
    const btn = root.querySelector('[data-facets-open]');
    btn && btn.setAttribute('aria-expanded', 'false');
    (lastTrigger && document.contains(lastTrigger) ? lastTrigger : btn)?.focus();
  };

  const buildUrl = (form) => {
    const data = new FormData(form);
    const params = new URLSearchParams();
    for (const [k, v] of data.entries()) { if (v !== '') params.append(k, v); }
    return `${form.action.split('?')[0]}?${params.toString()}`;
  };

  const render = async (url, push = true) => {
    const wrap = results();
    wrap.setAttribute('aria-busy', 'true');
    const openFacet = Array.from(wrap.querySelectorAll('[data-facet]')).findIndex((d) => d.open);
    const wasOpen = panel()?.classList.contains('is-open');
    const sep = url.includes('?') ? '&' : '?';
    try {
      const res = await fetch(`${url}${sep}section_id=${sectionId}`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('[data-collection-results]');
      if (!next) throw new Error('render');
      wrap.innerHTML = next.innerHTML;
      if (push) history.pushState({ url }, '', url);
      if (wasOpen && isMobile()) {
        panel().classList.add('is-open'); panel().setAttribute('role', 'dialog'); panel().setAttribute('aria-modal', 'true');
        if (openFacet > -1) { const d = wrap.querySelectorAll('[data-facet]')[openFacet]; if (d) d.open = true; }
      }
      const count = wrap.querySelector('.toolbar__count');
      if (count && announce) announce(count.textContent.trim());
    } catch (e) {
      window.location.href = url;
    } finally {
      wrap.removeAttribute('aria-busy');
    }
  };

  const onChange = debounce ? debounce((form) => render(buildUrl(form)), 450) : (form) => render(buildUrl(form));

  root.addEventListener('change', (e) => {
    const input = e.target.closest('[data-facet-input]');
    if (!input) return;
    const form = input.form || root.querySelector('[data-facets-form]');
    if (!form) return;
    // En celular los filtros se aplican al cambiar, y el botón muestra el nuevo total.
    onChange(form);
  });

  root.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-facets-form]');
    if (!form) return;
    e.preventDefault();
    closePanel();
    render(buildUrl(form));
  });

  root.addEventListener('click', (e) => {
    const open = e.target.closest('[data-facets-open]');
    if (open) { openPanel(open); return; }
    if (e.target.closest('[data-facets-close]')) { closePanel(); return; }
    const remove = e.target.closest('[data-facet-remove], [data-facets-clear], .pagination a');
    if (remove) { e.preventDefault(); closePanel(); render(remove.href); if (remove.closest('.pagination')) root.scrollIntoView({ behavior: 'smooth' }); return; }
    // Cerrar desplegables de escritorio al abrir otro
    const summary = e.target.closest('.facet__summary');
    if (summary && !isMobile()) {
      root.querySelectorAll('[data-facet][open]').forEach((d) => { if (d !== summary.parentElement) d.open = false; });
    }
  });

  document.addEventListener('click', (e) => {
    if (isMobile()) {
      const p = panel();
      if (p && p.classList.contains('is-open') && !p.contains(e.target) && !e.target.closest('[data-facets-open]')) closePanel();
      return;
    }
    if (!e.target.closest('[data-facet]')) root.querySelectorAll('[data-facet][open]').forEach((d) => { d.open = false; });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (panel()?.classList.contains('is-open')) { closePanel(); return; }
    const open = root.querySelector('[data-facet][open]');
    if (open && !isMobile()) { open.open = false; open.querySelector('summary').focus(); }
  });

  // Mantener el foco dentro del panel en celular
  root.addEventListener('keydown', (e) => {
    const p = panel();
    if (e.key !== 'Tab' || !p || !p.classList.contains('is-open')) return;
    const focusables = Array.from(p.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, summary')).filter((el) => el.offsetParent !== null);
    if (!focusables.length) return;
    const first = focusables[0]; const last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  window.addEventListener('popstate', (e) => { render(e.state?.url || window.location.href, false); });
})();
